import { FC } from 'react';
import { Backdrop, Modal } from '@mui/material';
import SecondTypeButton from 'src/components/Items/button/SecondTypeButton';
import './styles.scss';
import './media.scss';

interface IProps {
  open: boolean;
  handleClose: () => void;
}

const HostModal: FC<IProps> = ({ open, handleClose }) => {
  return (
    <Modal open={open} onClose={handleClose} BackdropComponent={Backdrop} closeAfterTransition>
      <div className='warning-modal'>
        <p>
          To successfully upload the front and back of the driver's license, please ensure that it
          is uploaded separately, as online check-in requires individual uploads for both the front
          and back of the driver's license, along with proof of insurance. You might want to check
          the file format or size. If the front and back of the license is saved in a single file,
          consider taking a screenshot of the back and uploading it separately.
        </p>
        <div className='warning-modal__container'>
          <SecondTypeButton children='Close' onClick={handleClose} />
        </div>
      </div>
    </Modal>
  );
};
export default HostModal;
